import axios from 'axios';
import baseService from '../shared/baseService';
import { NewsStatus } from '../Features/Classification/enum/NewsStatus';

const InfluencerService = (spreadsheetId: number) =>
  baseService(`influencer/${spreadsheetId}`);

const updateStatusNews = (
  spreadsheetId: number,
  newsId: number,
  status: NewsStatus
) => axios.patch(`/influencer/${spreadsheetId}/${newsId}`, { status: status });

const getAll = (spreadsheetId: number, status: NewsStatus) =>
  axios.get(`/influencer/${spreadsheetId}?classificationStatus=${status}`);

const getInfluencerFiltersClassification = (clientId: number) =>
  axios.get(`influencer/${clientId}/classification_filters`);

const putClassification = (influencerID: number, data: any) =>
  axios.put(`influencer/${influencerID}`, data);

const putStatusRevisor = (influencerID: number, data: any) =>
  axios.put(`influencer/${influencerID}/revisor`, data);

const putClassificationInfluencer = (influencerID: number, data: any) =>
  axios.put(`influencer/${influencerID}/classification`, data);

const putInfluencerValidate = (
  influencerID: number,
  clientId: any,
  ignoreQuotaLimit: any,
  prazoEntrega: string
) =>
  axios.put(
    `influencer/${influencerID}/validate`,
    { clientId, ignoreQuotaLimit, prazoEntrega },
    { headers: { 'Content-Type': 'application/json' } }
  );

const putInfluencerReject = (
  influencerID: number,
  clientId: any,
  observacaoRejeicao: string
) =>
  axios.put(
    `influencer/${influencerID}/reject`,
    { clientId, observacaoRejeicao },
    { headers: { 'Content-Type': 'application/json' } }
  );
const putStatusRevisorInfluencer = (influencerID: number, data: any) =>
  axios.put(`influencer/${influencerID}/classification-revisor`, data);
const getAllQuestions = () => axios.get('/influencer/questions');

const getAllClientQuestions = (clientId: number) =>
  axios.get(`influencer/${clientId}/questions`);

const getStatusClassification = () =>
  axios.get('/influencer/status/classification');

const getUserClientEnablements = (userId: number) =>
  axios.get(`influencer/${userId}/client_enablements`);

const getInfluencersByClient = (
  clientId: number,
  params?: Record<string, any>
) => axios.get(`influencer/${clientId}/client`, { params });

const getInfluencersBrandByClient = (clientId: number) =>
  axios.get(`influencer/${clientId}/brand`);

const getInfluencersResponsavelByUser = (userId: number) =>
  axios.get(`influencer/${userId}/user-responsavel`);

const getInfluencerById = (influencerId: number) =>
  axios.get(`influencer/${influencerId}/profile`);

const deleteInfluencersById = (influencerId: number) =>
  axios.delete(`influencer/${influencerId}/delete`);

const InfluencerSpreadsheetService = (userId: number) =>
  baseService(`users/${userId}/spreadsheetsinfluencer`);
const postSpreadsheetFileInfluencer = (userId: number, params: FormData) =>
  axios.post(`users/${userId}/spreadsheetsinfluencer`, params, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

const postSpreadsheetFileInfluencerICE = (userId: number, params: FormData) =>
  axios.post(`users/${userId}/spreadsheetsinfluencer/submit`, params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

const postSpreadsheetFileInfluencerDetachedICE = (
  userId: number,
  params: any
) =>
  axios.post(`users/${userId}/spreadsheetsinfluencer/submit-detached`, params);

const postCompanyDetachedICE = (userId: number, params: any) =>
  axios.post(
    `users/${userId}/spreadsheetsinfluencer/submit-company-detached`,
    params
  );
const postCampaignDetachedICE = (userId: number, params: any) =>
  axios.post(
    `users/${userId}/spreadsheetsinfluencer/submit-campaign-detached`,
    params
  );

const getAllByStatusInfluencer = (userId: number, status: number) =>
  axios.get(`users/${userId}/spreadsheetsinfluencer?status=${status}`);
const getClassifiedSpreadsheetInfluencer = (userId: number) =>
  axios.get(`users/${userId}/spreadsheetsinfluencer/classified`);

export default {
  InfluencerSpreadsheetService,
  postSpreadsheetFileInfluencer,
  getAllByStatusInfluencer,
  getClassifiedSpreadsheetInfluencer,
  getInfluencerFiltersClassification,
  InfluencerService,
  updateStatusNews,
  getAll,
  getAllQuestions,
  getStatusClassification,
  putClassification,
  putStatusRevisor,
  postSpreadsheetFileInfluencerICE,
  postSpreadsheetFileInfluencerDetachedICE,
  postCompanyDetachedICE,
  postCampaignDetachedICE,
  getAllClientQuestions,
  getUserClientEnablements,
  getInfluencersByClient,
  getInfluencersResponsavelByUser,
  getInfluencersBrandByClient,
  getInfluencerById,
  putClassificationInfluencer,
  putStatusRevisorInfluencer,
  putInfluencerValidate,
  putInfluencerReject,
  deleteInfluencersById,
};
